let selectedValue = '';
let isOpen = false;

const customSelect = document.querySelector('.custom-select');
if (customSelect) {
    const selectButton = customSelect.querySelector('.custom-select-button');
    const selectText = customSelect.querySelector('.custom-select-text');
    const selectDropdown = customSelect.querySelector('.custom-select-dropdown');
    const selectOptions = customSelect.querySelectorAll('.custom-select-option');

    selectButton.addEventListener('click', function() {
        isOpen = !isOpen;
        customSelect.classList.toggle('open', isOpen);
        selectButton.setAttribute('aria-expanded', isOpen);

        if (isOpen) {
            selectDropdown.focus();
        }
    });

// handle selection
    selectOptions.forEach(option => {
        option.addEventListener('click', function() {
            const data = this.dataset;
            const text = this.textContent;

            // update value
            selectedValue = data.value;
            selectText.textContent = text;

            // update state
            selectOptions.forEach(opt => opt.classList.remove('selected'));
            this.classList.add('selected');

            // close
            isOpen = false;
            customSelect.classList.remove('open');
            selectButton.setAttribute('aria-expanded', false);

            let details = {
                text
            }
            for (let d in data) {
                details[d] = data[d];
            }

            // trigger change event, to be used in filtering
            customSelect.dispatchEvent(new CustomEvent('change', {detail: details}));
        });
    });

    //close when outside
    document.addEventListener('click', function(e) {
        if (!customSelect.contains(e.target) && isOpen) {
            isOpen = false;
            customSelect.classList.remove('open');
            selectButton.setAttribute('aria-expanded', false);
        }
    });

    // keyboard nav
    selectButton.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectButton.click();
        }
    });
}